import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import appointmentBW from "../../Assets/Images/appointmentBW.png";
import Widgets from "../../Widgets/index";
import "./ApproveAppointment.css";
import utils from "../../Utils/index";
import { t } from "../../Utils/translate";
import ApproveAppointmentDetail from "../../Widgets/ApproveAppointment/ApproveApointmentDetail1";
import { hospitalAppointment } from "../../Services/clinicService";
import clinicService from "../../Services/clinicService";
import authService from "../../Services/authService";

function ApprovedAppointment() {
  const state = useLocation();
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [topHeight, setTopHeight] = useState(0);
  const [selectedAppointmentIndex, setSelectedAppointmentIndex] = useState(0);
  const [selectedSlot, setSelectedSlot] = useState("all");
  // const [selectedDoctor, setSelectedDoctor] = useState(null); // State to track selected doctor
  const [appointments, setAppointments] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null); // State to track selected doctor
  const [doctorOptions, setDoctorOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userNameErr, setUserNameErr] = useState("");
  const [doctorDetails, setDoctorDetails] = useState([]);
  const isDoctorListFetched = useRef(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [zoomClass, setZoomClass] = useState("zoom-default");
  const [zoomClass2, setZoomClass2] = useState("zoom-default");
  const [showTab, setShowTab] =useState(true)
  const location = useLocation();
  const [doctorCount,setDoctorCount] = useState([])
  const [hospitalCount,setHospitalCount] = useState([])
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === 'true');
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMobileView(true);
        setShowTab(false)
      } else {
        setMobileView(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const newDate = moment(state?.state?.date).format("YYYY-MM-DD");
    if (doctorOptions && doctorOptions.length > 0 && state.state) {
      const selectedDoc = doctorOptions.find(
        (doctor) => doctor.value === state.state.doctorId
      );
      setDate(newDate);
      setSelectedDoctor(selectedDoc.value);
      fetchAppointments(selectedDoc.value, selectedSlot, newDate);
    }
    if (doctorOptions && doctorOptions.length > 0 && state.state) {
      setSelectedAppointmentIndex(state.state.appointmentId);
    }

    if (authService.getIsDoctorLogin() === "true" && state.state) {
      setSelectedAppointmentIndex(state.state.appointmentId);
      setDate(newDate);
      fetchAppointments(selectedDoctor, selectedSlot, newDate);
    }
  }, [doctorOptions]);

  useEffect(() => {
    if (location.state) {
      setSelectedAppointmentIndex(state?.state?.appointmentId);
      fetchAppointments(selectedDoctor, selectedSlot);
    }
  }, [location.state]);


  const updateZoomClass = () => {
    const viewportWidth = window.innerWidth;
    const screenWidth = window.screen.width;
    const zoomLevel = viewportWidth / screenWidth;

    if (zoomLevel >= 1.1) {
      setZoomClass("zoom1-110"); // Apply this class for 110% zoom
      setZoomClass2("zoom2-110");
    } else if (zoomLevel >= 1.0 && zoomLevel < 1.1) {
      setZoomClass("zoom1-100"); // Apply this class for 100% zoom
      setZoomClass2("zoom2-100");
    } else if (zoomLevel >= 0.9 && zoomLevel < 1.0) {
      setZoomClass("zoom1-90"); // Apply this class for 90% zoom
      setZoomClass2("zoom2-90");
    } else if (zoomLevel >= 0.8 && zoomLevel < 0.9) {
      setZoomClass("zoom1-80");
      setZoomClass2("zoom2-80");
    } else if (zoomLevel >= 0.6 && zoomLevel < 0.7) {
      setZoomClass("zoom1-70");
      setZoomClass2("zoom2-70");
    } else {
      setZoomClass("zoom-default"); // Fallback class for other zoom levels
    }
  };

  useEffect(() => {
    window.addEventListener("resize", updateZoomClass);
    updateZoomClass(); // Initial check
    return () => window.removeEventListener("resize", updateZoomClass);
  }, []);

  const selectedAppointment = appointments.find(
    (appointment) => appointment._id === selectedAppointmentIndex
  );

  const handleDoctorChange = async (selectedOption) => {
    setSelectedDoctor(selectedOption.value);
    await refreshAppointments();
    await fetchAppointments(selectedOption.value);
  };
  
  const fetchAppointments = async (doctorId , selectedSlot,  newDate) => {
    const requestBody = {
      date: newDate || date || new Date().toISOString().split("T")[0],
      doctor: doctorId || "defaultDoctorId",
      // statuses: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
      statuses: ["SCHEDULED", "STARTED", "COMPLETED"],
    };

    const docBody = {
      date: newDate || date || new Date().toISOString().split("T")[0],
      statuses: ["SCHEDULED", "STARTED", "COMPLETED"],
    };

    const jwtToken = localStorage.getItem("FV_sessionToken");
    try {
      setIsLoading(true);
      let apiResponse;
      if (authService.getIsDoctorLogin() === "true") {
        apiResponse = await clinicService.docGetAllAppointment(docBody);
        setAppointments(apiResponse.data.appointments);
        const appointmentCount = apiResponse.data.appointments.filter(
          (appointment) => ["SCHEDULED", "STARTED"].includes(appointment.status)
        ).length;
        setDoctorCount(appointmentCount)
        if (apiResponse.data.appointments.length > 0) {
          if (!state.state) {
            setSelectedAppointmentIndex(apiResponse.data.appointments[0]._id);
          }else{
            const selectedAppointment = apiResponse.data.appointments.find(
              (appointment) => appointment._id === state.state.appointmentId
            );
            if(!selectedAppointment){
              setSelectedAppointmentIndex(apiResponse.data.appointments[0]._id)
            }else{
              setSelectedAppointmentIndex(selectedAppointment._id)
            }
          }
            
        }
      } else if (authService.getIsDoctorLogin() === "false") {
        apiResponse = await hospitalAppointment(requestBody, jwtToken);
        const appointmentCount = apiResponse.appointments.filter(
          (appointment) => ["SCHEDULED", "STARTED"].includes(appointment.status)
        ).length;
        setDoctorCount(appointmentCount)
        if (apiResponse) {
          setAppointments(apiResponse.appointments);
          console.log(apiResponse.appointments)
          if (apiResponse.appointments.length > 0) {
            if (!state.state) {
              setSelectedAppointmentIndex(apiResponse.appointments[0]._id);
            }else{
              const selectedAppointment = apiResponse.appointments.find(
                (appointment) => appointment._id === state.state.appointmentId
              );
              if(!selectedAppointment){
                setSelectedAppointmentIndex(apiResponse.appointments[0]._id)
              }else{
                setSelectedAppointmentIndex(selectedAppointment._id)
              }
            }
              
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // console.error("Error fetching appointments by doctor:", error.message);
    }
  };

  useEffect(() => {
    const getClinicProfile = async () => {
      try {
        setIsLoading(true);
        let response;
        if (authService.getIsDoctorLogin() === "false") {
          response = await clinicService.getDoctorList();
        }
        setIsLoading(false);
        if (response && response.status) {
          const doctors = response.data.doctors;
          const options = doctors.map((doctor) => ({
            value: doctor._id,
            label: doctor.name,
          }));
          setDoctorOptions(options);
          if (options.length > 0 && !state.state) {
            setSelectedDoctor(options[0].value);
            await fetchAppointments(options[0].value); // Fetch appointments for the first doctor
          }
        }
      } catch (error) {
        setIsLoading(false);
        // console.error("Error fetching doctor list:", error);
      }
    };

    if (!isDoctorListFetched.current) {
      getClinicProfile();
      isDoctorListFetched.current = true; // Prevent future calls
    }

    if (authService.getIsDoctorLogin() === "true") {
      setIsDoctorLogin(true);
    } else if (authService.getIsDoctorLogin() === "false") {
      setIsDoctorLogin(false);
    }
  }, []);

  useEffect(() => {
    if (authService.getIsDoctorLogin() === "true") {
      refreshAppointments();
    }
  }, []);

  const handleCardClick = (index) => {
    console.log(index, selectedAppointmentIndex);
    if (selectedAppointmentIndex === index) {
      // If the same card is clicked again, deselect it
      setSelectedAppointmentIndex(index);
      setShowTab(true);
    } else {
      // Otherwise, select the clicked card
      setSelectedAppointmentIndex(index);
      setShowTab(true);
    }
    
  };

  function getAgeFromDateOfBirth(patientAge) {
    return moment().diff(patientAge, "years");
  }

  const handleSlotChange = (slot) => {
    setSelectedSlot(slot.value);
  };

  const handleDateChange = (newDate) => {
    //  refreshAppointments();
    setDate(newDate);
    // Fetch appointments based on the selected date, doctor, and status
    // fetchAppointments(selectedDoctor);
    fetchAppointments(selectedDoctor, selectedSlot, newDate);
  };
  // useEffect(() => {
  //   if (selectedDoctor && selectedSlot) {
  //     fetchAppointments(selectedDoctor, selectedSlot);
  //   }
  //   if (authService.getIsDoctorLogin() === "true") {
  //     fetchAppointments(selectedDoctor, selectedSlot);
  //   }
  // }, [date]);
  const refreshAppointments = async () => {
    if (selectedDoctor) {
      await fetchAppointments(selectedDoctor);
    }

    if (authService.getIsDoctorLogin() === "true") {
      await fetchAppointments(selectedDoctor, selectedSlot);
    }
  };

  return (
    <React.Fragment>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="screen-name p-3">
        <span style={{ marginRight: "5px" }}>{t("appointments")}</span>
        {doctorCount > 0
          ? `(${doctorCount})`
          : hospitalCount > 0
          ? `(${hospitalCount})`
          : null}
      </div>
      <div className="appointment-parent px-3">
        {/* {authService.getIsDoctorLogin() == "false" && <FloatingScanner />} */}
        <div className="appointment-parent-col appointment-parent-col-1">
          <div className="app-section-left">
            <div className="appointment-view-parent">
              <Widgets.AppointmentCalender
                className="box1"
                styles={{
                  height: topHeight + "px",
                }}
                onselect={handleDateChange}
                // onselect={(date) => {
                //   setDate(date);
                // }}

                setTopHeight={(height) => {
                  setTopHeight(height);
                }}
                value={date}
              />

              <div
                className={`appointment-view box2 appointment-view-height`}
                style={{
                  top: topHeight + 7 + "rem",
                }}
              >
                <div className="appointment-card-filter-view">
                  <div className="appointment-card-filter-view-col-1 appointment-card-filter-view-approved-appointment-adjust filterRes">
                    {!isDoctorLogin && (
                      <div className="appointment-card-filter-view-col-1-2">
                        <Select
                          isSearchable={true}
                          className="me-1"
                          styles={utils.appStyles.appointmentDropDown}
                          options={doctorOptions}
                          value={doctorOptions.find(
                            (option) => option.value === selectedDoctor
                          )}
                          onChange={handleDoctorChange}
                        />
                      </div>
                    )}
                    <div>
                      <div className={"refresh-appointment-list-icon-parent"}>
                        <i
                          id="refresh-appointment"
                          className="ri-refresh-line refresh-appointment-list-icon"
                          onClick={
                            refreshAppointments
                            // rotateRefreshIcon();
                            // getAppointmentList();
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <Widgets.AppointmentComponent
                  appointment={appointments}
                  selectedAppointmentIndex={selectedAppointmentIndex}
                  handleCardClick={handleCardClick}
                  specificDate={date}
                  selectedSlot={selectedSlot} // Pass the selected session as prop to AppointmentComponent
                  selectedDoctor={selectedDoctor}
                  requestApp={false}
                  refreshAppointments={() => refreshAppointments}
                  zoomClass2={zoomClass2}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="appointment-parent-col appointment-parent-col-2">
          <div>
            {selectedAppointmentIndex !== null && showTab ? (
              <ApproveAppointmentDetail
                appointment={selectedAppointment}
                refreshAppointments={() => refreshAppointments()}
                showTab={showTab}
                setShowTab={setShowTab}
              />
            ) : (
              <div className="appointment-section-right-placeholder">
                <div className="appointment-details d-flex justify-content-between">
                  <div></div>
                  <div className="text-center">{t("appointmentDetails")}</div>
                  <div></div>
                </div>

                <div className="appointment-details-container p-3 bg-white d-flex justify-content-center ">
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      className="no-appointments-image"
                      src={appointmentBW}
                      alt="noappointment"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ApprovedAppointment;
